var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M12.062 0H4.938A4.944 4.944 0 0 0 0 4.938v7.124A4.944 4.944 0 0 0 4.938 17h7.124A4.944 4.944 0 0 0 17 12.062V4.938A4.944 4.944 0 0 0 12.062 0zm3.61 12.062c0 1.99-1.62 3.61-3.61 3.61H4.938c-1.99 0-3.61-1.62-3.61-3.61V4.938c0-1.99 1.62-3.61 3.61-3.61h7.124c1.99 0 3.61 1.62 3.61 3.61v7.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.5 3.918A4.587 4.587 0 0 0 3.918 8.5 4.587 4.587 0 0 0 8.5 13.082 4.587 4.587 0 0 0 13.082 8.5 4.587 4.587 0 0 0 8.5 3.918zm0 7.836A3.257 3.257 0 0 1 5.246 8.5 3.257 3.257 0 0 1 8.5 5.246 3.257 3.257 0 0 1 11.754 8.5 3.257 3.257 0 0 1 8.5 11.754z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.142,
    cy: 3.858,
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.783f7b37babdb71e8147a8c1d00955f4.svg";
export { ForwardRef as ReactComponent };